// MentionsLegales.jsx
// ———————————————————————————————————————————————————————————
// Page Mentions légales (style Safe for Bike)
// Remplacer les [CHAMPS] puis router vers /mentions-legales
// ———————————————————————————————————————————————————————————

import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Link as MuiLink,
} from "@mui/material";

function LegalLayout({ title, subtitle, children }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5, px: 2 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 5, md: 6 },
          backgroundColor: "#F8F8F8",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <Typography
          gutterBottom
          sx={{
            color: "#000",
            fontWeight: 900,
            fontSize: { xs: "2.2rem", md: "3rem" },
            lineHeight: 1.2,
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ color: "#444", fontWeight: 500, fontSize: "1.1rem", mb: 3 }}>
            {subtitle}
          </Typography>
        )}
        <Divider sx={{ mb: 4 }} />
        {children}
      </Paper>
    </Box>
  );
}

function SectionTitle({ children }) {
  return (
    <Typography sx={{ fontWeight: 800, fontSize: { xs: "1.35rem", md: "1.55rem" }, color: "#000", mt: 3, mb: 1 }}>
      {children}
    </Typography>
  );
}

function Paragraph({ children }) {
  return (
    <Typography sx={{ color: "#444", fontSize: "1.05rem", lineHeight: 1.7, mb: 2 }}>
      {children}
    </Typography>
  );
}

export default function MentionsLegales() {
  return (
    <>
      <Navbar />
      <Box sx={{ height: "50px" }} />
        <LegalLayout
        title={<><span>Mentions </span><Box component="span" sx={{ color: "#449F2D" }}>légales</Box></>}
        subtitle="Informations d’identification de l’éditeur, de l’hébergeur et mentions spécifiques à l’assurance."
        >
        <SectionTitle>Éditeur du site</SectionTitle>
        <Paragraph>
            <strong>[SAFE FOR BIKE]</strong> [forme juridique] au capital de [montant] € – RCS [ville] n° [SIREN].<br />
            Siège social : [adresse complète].<br />
            Contact : <MuiLink href="mailto:[contact@email]">[contact@email]</MuiLink>
            {" "}– [téléphone]
        </Paragraph>

        <SectionTitle>Responsable de la publication</SectionTitle>
        <Paragraph>[Nom, fonction]</Paragraph>

        <SectionTitle>Hébergement</SectionTitle>
        <Paragraph>
            [Nom de l’hébergeur] – [adresse] – [téléphone]
        </Paragraph>

        <SectionTitle>Intermédiaire d’assurance</SectionTitle>
        <Paragraph>
            [Safe for Bike] exerce en qualité de <strong>[courtier / agent / mandataire]</strong> d’assurance,
            immatriculé à l’<strong>ORIAS</strong> sous le n° <strong>[XXXXXXXX]</strong> (vérifiable sur orias.fr).<br />
            Responsabilité civile professionnelle : [assureur, n° de police] – Garantie financière : [oui/non, organisme].<br />
            Autorité de contrôle : <strong>ACPR</strong> – 4 place de Budapest, CS 92459, 75436 Paris Cedex 09.
        </Paragraph>

        <SectionTitle>Assureur(s) porteur(s) du risque</SectionTitle>
        <Paragraph>
            [Raison sociale complète], [forme], [adresse], [RCS], [pays].
        </Paragraph>

        <SectionTitle>Propriété intellectuelle</SectionTitle>
        <Paragraph>
            Les contenus de ce site (textes, images, logos, code) sont protégés.
            Toute reproduction, représentation ou diffusion non autorisée est interdite.
        </Paragraph>

        <SectionTitle>Liens externes</SectionTitle>
        <Paragraph>
            Des liens vers des sites tiers peuvent être proposés. Nous n’exerçons aucun contrôle sur leur contenu
            et déclinons toute responsabilité s’y rapportant.
        </Paragraph>

        <SectionTitle>Signalement de contenu illicite</SectionTitle>
        <Paragraph>
            Pour signaler un contenu manifestement illicite : [email dédié], en précisant l’URL, la description et vos coordonnées.
        </Paragraph>

        <SectionTitle>Médiation de la consommation</SectionTitle>
        <Paragraph>
            Après réclamation (voir « Conditions générales »), vous pouvez saisir le médiateur :
            [Nom du médiateur] – [coordonnées] – [site].
        </Paragraph>

        <SectionTitle>Données personnelles & cookies</SectionTitle>
        <Paragraph>
            Consultez notre <MuiLink href="/politique-de-confidentialite">Politique de confidentialité</MuiLink>
            {" "}et notre <MuiLink href="/politique-de-cookies">Politique de cookies</MuiLink>.
        </Paragraph>

        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
            [email de contact] – [adresse postale]
        </Paragraph>
        </LegalLayout>
        <Footer />
    </>
  );
}